module.exports = __webpack_public_path__ + "media/images/favicon-d874a8a5.ico";